<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Gift`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_a0ec3b461a__clip0_395_912)"><path d="M16.2384 18.3333H4" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.37361 0.959641C6.98309 0.569117 6.34992 0.569117 5.9594 0.959641C5.56887 1.35017 5.56887 1.98333 5.9594 2.37385L7.43637 3.85083H2.2C1.53726 3.85083 1 4.38809 1 5.05083V7.3C1 7.86508 1.39058 8.33893 1.9165 8.46632V17.3333C1.9165 18.4378 2.81193 19.3333 3.9165 19.3333H10H16.0832C17.1877 19.3333 18.0832 18.4378 18.0832 17.3333V8.4664C18.6093 8.33913 19 7.86519 19 7.3V5.05083C19 4.38809 18.4627 3.85083 17.8 3.85083H12.5633L14.0403 2.37385C14.4308 1.98333 14.4308 1.35017 14.0403 0.959641C13.6498 0.569117 13.0166 0.569117 12.6261 0.959641L9.99984 3.58587L7.37361 0.959641ZM9 9.33325H3.9165V17.3333H9V9.33325ZM11 17.3333V9.33325H16.0832V17.3333H11Z"/></g><defs><clipPath id="svg_a0ec3b461a__clip0_395_912"><path d="M0 0H20V20H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconGift',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
